<script setup lang="ts">
/** While Lighthouse support can see the user's email (D-16): one slim line with the end time and Revoke. Nothing otherwise. */
import { computed } from 'vue'
import useSupportAccess from '@/composables/useSupportAccess'
import { formatGrantUntil } from '@/native/supportAccess'

const { activeGrant, now, busy, revoke } = useSupportAccess()
const until = computed(() => formatGrantUntil(activeGrant.value?.granted_until ?? null, now.value))
</script>

<template>
    <div v-if="activeGrant" class="support-access-banner" role="status" data-testid="support-access-banner">
        <i class="fa-regular fa-headset" aria-hidden="true" />
        <span class="truncate">Lighthouse support can see your email until {{ until }}</span>
        <span aria-hidden="true">·</span>
        <button type="button" class="support-access-banner__revoke" :disabled="busy" @click="revoke">
            {{ busy ? 'Revoking…' : 'Revoke' }}
        </button>
    </div>
</template>

<style scoped>
.support-access-banner {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 32px;
    padding: 4px 12px;
    font-size: 12px;
    color: var(--lh-text-2, #3f3f3f);
    background: var(--lh-raised, #f5f5f5);
    border-bottom: 1px solid var(--lh-border, #e5e5e5);
}
html.native-app .support-access-banner {
    padding-top: calc(env(safe-area-inset-top, 0px) + 4px);
}
.support-access-banner__revoke {
    min-height: 28px;
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 2px;
}
</style>
